import { render } from "./FinancialHistoryTab.vue?vue&type=template&id=b4a06362"
import script from "./FinancialHistoryTab.vue?vue&type=script&lang=js"
export * from "./FinancialHistoryTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__